<h6 class="title text-black" *ngIf="_upsell.length > 0">
  We noticed you don't have any markers...
</h6>
<div class="items">
  <div class="item" *ngFor="let product of _upsell">
    <img
      height="400"
      width="400"
      *ngIf="product.image"
      class="product-image w-100 h-auto"
      [ngSrc]="product.image"
      ngSrcset="400w, 500w, 600w"
      [loaderParams]="{ aspect: 1 }"
    />
    <div class="d-flex mt-2 flex-column product-meta">
      <div class="flex-row d-flex w-100 justify-content-between">
        <div class="product-title">
          {{
            product.title.includes(" | ")
              ? product.title.split(" | ")[0]
              : product.title
          }}
        </div>
      </div>
      <div class="product-prices d-flex flex-row" *ngIf="product.prices['AUD']">
        <div class="price">
          {{ product.prices["AUD"].price || product.min_price | currency }}
        </div>
        <div
          *ngIf="product.prices['AUD'].min_compare_at_price"
          class="price strike"
        >
          {{ product.prices["AUD"].min_compare_at_price | currency }}
        </div>
      </div>
    </div>
    <div
      class="add mt-1 d-flex justify-content-center align-items-center"
      (click)="addToCart(product)"
    >
      Add<svg
        class="ms-1"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.9"
          d="M2.81455 8.7457L13.1854 8.7457"
          stroke="black"
          stroke-width="1.33333"
          stroke-linecap="square"
        />
        <path
          opacity="0.9"
          d="M8.0001 3.5604L8.0001 13.9313"
          stroke="black"
          stroke-width="1.33333"
          stroke-linecap="square"
        />
      </svg>
    </div>
  </div>
</div>
